import './styles.scss'
import React from 'react'
import { I18n, Translate } from 'react-redux-i18n'
import { Button } from 'reactstrap'
import es from 'react-phone-input-2/lang/es.json'

import { composerAct } from 'redux/actions'
import { InputChipsWithSearch, DropZoneFileUploader } from 'components/common'
import ModalMaxButtons from 'components/Form/TextEditor/ModalMaxButtons'
import ModalWrapper from 'components/ModalWrapper'
import { Button as ButtonForm, PhoneInput, SelectWithLabel, ConversationTemplateEditor } from 'components/Form'
import HtmlEditor from 'components/HtmlEditor'
import FilePreview from '../../../UploadFiles/FilePreview'
import Subjects from '../Subjects'
import ConversationOffline from '../ConversationOffline'
import { FILE_MAX_SIZE_CONVERSATION } from 'constants/filesMaxSize'
import { getChannelKey } from 'constants/channels'
import ActionsBar from './ActionsBar'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { lang } from 'utils/helpers'
const _ = require('lodash')

const ChatComposerUI = ({
  isChatmail, channelToken, chatmailHeader, users, handleContacts, setHeaderInput,
  chatmailInputButtons, toggleContactLockedModal, handleCloseChatmailField,
  conversationUser, getSubjects, loadingSubjects, setSubjectsIsOpen, subjectsIsOpen,
  composer, dispatch, setFilterValues, setIsSubjectFiltered, subjectsFilterOptions,
  filterValues, openOutboundAction, subjects, handleSelectSubject,
  handleStateSubject, handleReadSubject, statesOptions, chatmailCheckedSubjects,
  chatmailAllCheckedSubjects, setChatmailCheckedSubjects, handleAllCheckedSubjects,
  handleChangeMultipleSubjects, disclaimerMessage, onToggleNote, isOnline,
  useTemplate, setUseTemplate, channel, disableComposer, handleDragEnter,
  handleDragLeave, dropZoneIsVisible, composerAction, setFilesErrorMessage,
  setDropZoneIsVisible, showShortcutMenu, shortcuts, buildShortcutMenu,
  onPasteAttachments, messageType, sending, onWriteMessage, message, onKeyUp,
  setRefEditor, onToggleReset, isVirtualAssistantActive, setShowAIResponses,
  showAIResponses, currentCampaing, withTag, show, provider, updateEditor,
  onToggleButtons, disabledSend, isInstagramPost, onToggleModal,
  setShowAudioRecorder, setShowCamera, setShowVideo, onToggleEmojis, showEmojis,
  onSelectEmoji, toggleOpenSendMessage, onSendMessage, resetComposer, uploading,
  filesErrorMessage, files, sendPhoto, showCamera, showVideo, sendVideo, uploadAudio,
  showAudioRecorder, showModalButtons, showModal, acceptTypes, showSendMessageModal,
  setShowSendMessageModal, get24HourModalTitle, setIsOpenModalSendSMS,
  modalMaxButtonsOpen, get24HourModalBody, setModalMaxButtonsOpen, replaceButtons,
  isOpenModalSendSMS, numbersSMS, numberSelected, setNumberSelected, numberToSendSMS,
  setDialCode, setNumberToSendSMS, numberToSendSMSMessage, errorModalSendSMS,
  sendSMSMessage, sendingSMS, gotoChannel, setVaSuggestion, handleDeleteSubject
}) => (
  <div className='chat-composer'>
    {isChatmail && (
      <div className='chatmail-header'>
        {channelToken && isChatmail
          ? (
            <div className='chatmail-header__from-container'>
              <strong>{I18n.t('chatmail_from')}</strong>
              <label>{channelToken}</label>
            </div>
          ) : null
        }
        {chatmailHeader.visibleFields.some(field => field === 'to') && (
          <div className='chatmail-header__field-container'>
            <strong>{I18n.t('chatmail_to')}</strong>
            <div className='chatmail-header__input-chips-container'>
              <InputChipsWithSearch
                customClassName='chatmail-header__input-chips'
                values={chatmailHeader.to}
                regex={/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/g}  // RegEx: Email
                data={users.to}
                onChange={values => {
                  handleContacts({ type: 'to', values })
                  setHeaderInput({ type: 'to', value: values.input })
                }}
                buttons={chatmailInputButtons}
                hiddenButtons={chatmailHeader.visibleFields}
                lockedChips={{
                  value: 1,
                  handle: toggleContactLockedModal
                }}
              />
            </div>
          </div>
        )}
        {chatmailHeader.visibleFields.some(field => field === 'cc') && (
          <div className='chatmail-header__field-container'>
            <strong>Cc</strong>
            <div className='chatmail-header__input-chips-container'>
              <InputChipsWithSearch
                customClassName='chatmail-header__input-chips'
                values={chatmailHeader.cc}
                regex={/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/g}  // RegEx: Email
                data={users.cc}
                onChange={values => {
                  handleContacts({ type: 'cc', values })
                  setHeaderInput({ type: 'cc', value: values.input })
                }}
              />
              <button type='button' className='chatmail-header__btn-close' onClick={() => handleCloseChatmailField({ field: 'cc' })}>
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
        )}
        {chatmailHeader.visibleFields.some(field => field === 'cco') && (
          <div className='chatmail-header__field-container'>
            <strong>Cco</strong>
            <div className='chatmail-header__input-chips-container'>
              <InputChipsWithSearch
                customClassName='chatmail-header__input-chips'
                values={chatmailHeader.cco}
                regex={/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/g}  // RegEx: Email
                data={users.cco}
                onChange={values => {
                  handleContacts({ type: 'cco', values })
                  setHeaderInput({ type: 'cco', value: values.input })
                }}
              />
              <button type='button' className='chatmail-header__btn-close' onClick={() => handleCloseChatmailField({ field: 'cco' })}>
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
        )}

        {/* CHATMAIL SUBJECTS */}
        {isChatmail ?
          <div className='chatmail-header__field-container'>
            <strong>{I18n.t('composer_select_label_subjects')}</strong>
            <Subjects
              conversationUser={conversationUser}
              getSubjects={getSubjects}
              loadingSubjects={loadingSubjects}
              setSubjectsIsOpen={setSubjectsIsOpen}
              subjectsIsOpen={subjectsIsOpen}
              composer={composer}
              dispatch={dispatch}
              setFilterValues={setFilterValues}
              setIsSubjectFiltered={setIsSubjectFiltered}
              subjectsFilterOptions={subjectsFilterOptions}
              filterValues={filterValues}
              openOutboundAction={openOutboundAction}
              subjects={subjects}
              handleSelectSubject={handleSelectSubject}
              handleStateSubject={handleStateSubject}
              handleReadSubject={handleReadSubject}
              statesOptions={statesOptions}
              chatmailCheckedSubjects={chatmailCheckedSubjects}
              chatmailAllCheckedSubjects={chatmailAllCheckedSubjects}
              setChatmailCheckedSubjects={setChatmailCheckedSubjects}
              handleAllCheckedSubjects={handleAllCheckedSubjects}
              handleChangeMultipleSubjects={handleChangeMultipleSubjects}
              handleDeleteSubject={handleDeleteSubject}
            />
          </div>
          : null}
      </div>
    )}

    <div
      className='chat-composer__chat-container'
      style={{
        border: channel === 'whatsapp' && useTemplate ? 'none' : null,
        backgroundColor: channel === 'whatsapp' && useTemplate ? 'transparent' : null,
      }}
    >
      {disclaimerMessage ? (
        <div className='chat-composer__disclaimer'>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-warning.svg')} alt='Disclaimer' />
          </figure>
          {disclaimerMessage}
        </div>
      ) : null}

      {(!isChatmail || composer.currentSubject?._id) ? (
        <>
          {channel === 'whatsapp' && useTemplate ? (
            <ConversationTemplateEditor
              conversationUser={conversationUser}
              channel={channel}
              provider={provider}
              channelToken={conversationUser?.channels?.[0].token}
              templateId={composer.selectedTemplate}
              text={composer.message}
              onChangeTemplate={template => {
                dispatch(composerAct.setMessageFromTemplate(template?._id, template))
              }}
              onChangeVariables={variables => dispatch(composerAct.setVariables(variables))}
              onChangeFiles={files => dispatch(composerAct.setFiles(files))}
              onSend={onSendMessage}
              onCancel={onToggleReset}

            />
          ) : null}
          <ConversationOffline
            key={`cv-online-${conversationUser.id}`}
            user={conversationUser}
            isNote={composer.messageType === 'note'}
            onToggleNote={onToggleNote}
            isOnline={isOnline}
            useTemplate={useTemplate}
            setUseTemplate={setUseTemplate}
            channel={channel}
            composer={composer}
          />
          <div
            className={`message-input ${disableComposer(conversationUser.isOnline, channel) ? 'disable-composer' : null}`}
            onDragEnter={disableComposer(conversationUser.isOnline, channel) ? null : handleDragEnter}
            onDragLeave={disableComposer(conversationUser.isOnline, channel) ? null : handleDragLeave}
            onClick={disableComposer(conversationUser.isOnline, channel) && composer.messageType !== 'note'
              ? () => dispatch(composerAct.setWallEnabledForSMS({ isWallEnabledForSMS: true }))
              : null
            }
            style={{ display: (isOnline || composer.messageType === 'note' || (channel !== 'whatsapp' && useTemplate)) ? 'block' : 'none' }}
          >
            {dropZoneIsVisible ? (
              <DropZoneFileUploader
                height={69.3}
                maxSize={FILE_MAX_SIZE_CONVERSATION}
                uploadFiles={files => composerAction.uploadFiles(files, channel === 'facebook_post' ? true : false)}
                onError={setFilesErrorMessage}
                onHiddenDropZone={() => setDropZoneIsVisible(false)}
              />
            ) : (
              <>
                {showShortcutMenu && shortcuts.length ? (
                  <div className='shortcuts'>
                    {buildShortcutMenu()}
                  </div>
                ) : null}
                <HtmlEditor
                  key={`editor-${conversationUser.id}`}
                  onPasteAttachments={onPasteAttachments}
                  editorCssClass={`${messageType ? messageType : ''}`}
                  readonly={(sending
                    || (!isOnline && composer.messageType !== 'note' && !composer.selectedTemplate && channel === 'whatsapp' ? true : false)
                    || (!isOnline && composer.messageType !== 'note' && !composer.tag && channel === 'facebook' ? true : false)
                    || (!isOnline && composer.messageType !== 'note' && !composer.tag && channel === 'instagram' ? true : false))
                    && (!isOnline ? true : false)
                  }
                  onChange={value => onWriteMessage({ target: { value: value || '' } })}
                  defaultValue={composer.message ? _.replace(composer.message, /\n/g, '<br>') : message && _.replace(message, /\n/g, '<br>')}
                  placeholder={messageType === 'text' ? I18n.t('dashboard_write-message') : I18n.t('dashboard_write-note')}
                  onKeyUp={(e)=>onKeyUp(e)}
                  setInstance={(instance) => setRefEditor(instance)}
                  channel={getChannelKey(channel)}
                  minHeight={70}
                  maxHeight={500}
                  isSmall
                  enter='P'//SI SE CAMBIA A BR, PRESENTA EL BUG DEL ENTER QUE MANDA EL CURSOR AL INICIO DE LA LINEA
                  buttonCloseEvent={!isOnline ? onToggleReset : undefined}
                />
              </>
            )}
          </div>

          {
            (channel === 'whatsapp' && useTemplate)
              ? null
              : (uploading || filesErrorMessage || files.length > 0)
                ? (
                  <div className='chat-composer__uploaded-files'>
                    {!filesErrorMessage && uploading && <Nixi1Spinner width='25px' height='25px' />}
                    {filesErrorMessage && <p className='files-error'>{I18n.t(filesErrorMessage)}</p>}
                    {!uploading && files.length > 0 && (
                      <div className='chat-composer__uploaded-files-preview'>
                        {files.map((file, key) => (
                          <FilePreview
                            key={file.url + key}
                            iconCleanedClose
                            id={key}
                            url={file.urlLong || file.url}
                            thumb={file.thumb}
                            shortUrl={file.url || file.urlLong}
                            type={file.mime}
                            mimeType={file.mimeType}
                            mimeSubtype={file.mimeSubtype}
                            extension={file.extension}
                            onRemoveFile={composerAction.removeFile}
                            withVirus={file.withVirus}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                )
                : null
          }

          <ActionsBar
            disableComposer={disableComposer}
            conversationUser={conversationUser}
            channel={channel}
            isVirtualAssistantActive={isVirtualAssistantActive}
            composer={composer}
            setShowAIResponses={setShowAIResponses}
            showAIResponses={showAIResponses}
            isChatmail={isChatmail}
            currentCampaing={currentCampaing}
            isOnline={isOnline}
            useTemplate={useTemplate}
            withTag={withTag}
            show={show}
            provider={provider}
            updateEditor={updateEditor}
            onToggleButtons={onToggleButtons}
            disabledSend={disabledSend}
            onToggleReset={onToggleReset}
            isInstagramPost={isInstagramPost}
            onToggleModal={onToggleModal}
            onToggleNote={onToggleNote}
            setShowAudioRecorder={setShowAudioRecorder}
            setShowCamera={setShowCamera}
            setShowVideo={setShowVideo}
            onToggleEmojis={onToggleEmojis}
            showEmojis={showEmojis}
            onSelectEmoji={onSelectEmoji}
            toggleOpenSendMessage={toggleOpenSendMessage}
            onSendMessage={onSendMessage}
            showCamera={showCamera}
            sendPhoto={sendPhoto}
            showVideo={showVideo}
            sendVideo={sendVideo}
            uploading={uploading}
            uploadAudio={uploadAudio}
            showAudioRecorder={showAudioRecorder}
            showModalButtons={showModalButtons}
            composerAction={composerAction}
            showModal={showModal}
            files={files}
            acceptTypes={acceptTypes}
            dispatch={dispatch}
            setVaSuggestion={setVaSuggestion}
          />
        </>
      ) : (
        <div className='chat-composer__chatmail-subject-info-container'>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-blocked.svg')} alt='Locked' />
          </figure>
          <p className='chat-composer__chatmail-subject-info'>{I18n.t('chatmail_info_subject')}</p>
          <ButtonForm
            clearPrimary
            value={I18n.t('btn_write')}
            onClick={() => openOutboundAction({ channel: 'chatmail' })}
          />
        </div>
      )}
    </div>

    <ModalMaxButtons
      isOpen={modalMaxButtonsOpen}
      toggle={() => setModalMaxButtonsOpen(!modalMaxButtonsOpen)}
      replaceAction={replaceButtons}
    />

    <ModalWrapper
      isOpen={showSendMessageModal}
      toggle={() => setShowSendMessageModal(false)}
      header={I18n.t(get24HourModalTitle())}
      body={<Translate value={get24HourModalBody()} dangerousHTML />}
      footer={
        <>
          <Button color='danger' onClick={() => setShowSendMessageModal(false)}>
            {I18n.t('dashboard_cancel')}
          </Button>
          <Button color='primary' onClick={() => setIsOpenModalSendSMS(true)}>
            {I18n.t('dashboard_send-sms')}
          </Button>{' '}
        </>
      }
    />

    <ModalWrapper
      id={'modalSendSMS'}
      isOpen={isOpenModalSendSMS}
      toggle={toggleOpenSendMessage}
      showClose={true}
      header={I18n.t('dashboard_send-sms')}
      body={
        <div className='seccion-fields-container'>
          <div className='seccion-fields'>
            <label>{I18n.t('conversations_sending_channel')}</label>
            <SelectWithLabel
              name='select_channel_sms'
              key='select_channel_sms'
              placeholder={lang('dashboard_select-channel')}
              classNameWrapper='select-channel-sms'
              options={numbersSMS}
              value={numberSelected}
              onChange={(value) => setNumberSelected(value)}
            />
          </div>
          {channel === 'facebook' || channel === 'chatweb' ? (
            <div className='seccion-fields'>
              <label>{`${I18n.t('conversations_set_number_of')} ${conversationUser.name}`}</label>
              <PhoneInput
                id='user_phone'
                localization={es}
                buttonClass='code_phone_btn'
                country='es'
                autoFormat
                enableSearch
                value={numberToSendSMS}
                onChange={(value) => {
                  setDialCode(`+${value.dialCode}`)
                  setNumberToSendSMS(`+${value.phone}`)
                }}
              />
              {numberToSendSMSMessage ? <span className='alert_for_sms' dangerouslySetInnerHTML={{ __html: numberToSendSMSMessage }}></span> : null}
            </div>
          ) : null}
        </div>
      }
      footer={
        <>
          {numbersSMS.length ?
            null : (
              <div className='wrapper-error'>
                <span>{I18n.t('conversations_message_config_sms')}</span>
              </div>
            )
          }
          {errorModalSendSMS ? (
            <div className='wrapper-error'>
              <span className='error'>{`${errorModalSendSMS}`}</span>
            </div>
          ) : null}
          <div className='footer-buttons-wrapper'>
            {numbersSMS.length ? (
              <ButtonForm secondary onClick={sendSMSMessage} isSubmitting={sendingSMS}>
                {I18n.t('dashboard_send')}
              </ButtonForm>
            ) : (
              <ButtonForm primary onClick={gotoChannel}>
                {I18n.t('buttons_config_sms')}
              </ButtonForm>
            )}
            <ButtonForm onClick={() => setIsOpenModalSendSMS(false)}>
              {I18n.t('dashboard_cancel')}
            </ButtonForm>
          </div>
        </>
      }
    />
  </div>
)

export default ChatComposerUI
